(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rockeron-comparison-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rockeron-motion-loop')) {
    customElements.define('rockeron-motion-loop', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.visible = false;
        this.userPaused = false;
        this.expectedPauses = 0;
        this.video.muted = true;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onPause = () => {
          if (this.expectedPauses > 0) this.expectedPauses -= 1;
          else this.userPaused = true;
        };
        this.onPlay = () => { this.userPaused = false; };
        this.onVisibility = () => this.updatePlayback();
        this.onMotion = () => this.updatePlayback();
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('play', this.onPlay);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onMotion);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.35;
            this.updatePlayback();
          }, { threshold: [0, 0.35] });
          this.observer.observe(this);
        }
      }
      pauseVideo() {
        if (!this.video.paused) {
          this.expectedPauses += 1;
          this.video.pause();
        }
      }
      updatePlayback() {
        if (!this.visible || document.hidden || this.motion.matches) {
          this.pauseVideo();
          return;
        }
        if (!this.userPaused && this.video.paused) {
          this.video.play().then(() => {
            if (!this.isConnected || !this.visible || document.hidden || this.motion.matches) this.pauseVideo();
          }).catch(() => {});
        }
      }
      disconnectedCallback() {
        if (!this.video) return;
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.motion.removeEventListener('change', this.onMotion);
        this.video.removeEventListener('pause', this.onPause);
        this.video.removeEventListener('play', this.onPlay);
        this.video.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rockeron-core-compatibility-check"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rockeron-core-check')) {
    customElements.define('rockeron-core-check', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.variants = new Map(JSON.parse(this.querySelector('[data-core-variants]').textContent).map(v => [String(v.id), v]));
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.permits = new WeakMap();
        this.pending = null;
        document.addEventListener('submit', event => this.intercept(event), {capture: true, signal});
        this.querySelectorAll('[data-core-cancel]').forEach(button => button.addEventListener('click', () => this.dialog.close(), {signal}));
        this.querySelector('[data-core-confirm]').addEventListener('click', () => this.confirm(), {signal});
        this.dialog.addEventListener('close', () => {
          this.pending = null;
          if (this.previousOverflow !== undefined) document.documentElement.style.overflow = this.previousOverflow;
          this.previousOverflow = undefined;
          if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll: true});
        }, {signal});
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, {signal});
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.previousOverflow !== undefined) document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      intercept(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.js)?\/?$/.test(new URL(form.action, location.href).pathname)) return;
        const id = String(new FormData(form).get('id') || '');
        if (!this.variants.has(id)) return;
        const permit = this.permits.get(form);
        this.permits.delete(form);
        if (permit === id) return;
        if (event.submitter?.name === 'checkout') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!this.variants.get(id).available || event.submitter?.disabled || event.submitter?.getAttribute('aria-disabled') === 'true') return;
        if (!form.noValidate && !form.reportValidity()) return;
        if (this.dialog.open) return;
        this.pending = {form, id, submitter: event.submitter};
        this.querySelector('[data-core-variant-title]').textContent = this.variants.get(id).title;
        this.returnFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.querySelector('[data-core-cancel]').focus({preventScroll: true});
      }
      confirm() {
        const pending = this.pending;
        if (!pending || !this.dialog.open || !pending.form.isConnected) return;
        const {form, submitter} = pending;
        const id = String(new FormData(form).get('id') || '');
        if (id !== pending.id || !this.variants.get(id)?.available || submitter?.disabled) {
          this.dialog.close();
          return;
        }
        this.pending = null;
        this.dialog.close();
        this.permits.set(form, id);
        try {
          if (submitter?.form === form) form.requestSubmit(submitter);
          else form.requestSubmit();
        } finally {
          this.permits.delete(form);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rockeron-setup-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rockeron-setup-picker')) {
    customElements.define(
      'rockeron-setup-picker',
      class RockeronSetupPicker extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.handleChange);
          this.updatePanels(false);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.handleChange);
        }

        handleChange = (event) => {
          if (!event.target.matches('input[type="radio"]')) return;
          this.updatePanels(true);
        };

        updatePanels = (animate) => {
          const trainer = this.querySelector('input[name^="rsp-trainer-"]:checked')?.value;
          const front = this.querySelector('input[name^="rsp-front-"]:checked')?.value;
          const apply = () => {
            this.querySelectorAll('[data-rsp-trainer-panel]').forEach((panel) => {
              const active = panel.dataset.rspTrainerPanel === trainer;
              panel.hidden = !active;
              panel.setAttribute('aria-hidden', String(!active));
            });
            this.querySelectorAll('[data-rsp-front-panel]').forEach((panel) => {
              const active = panel.dataset.rspFrontPanel === front;
              panel.hidden = !active;
              panel.setAttribute('aria-hidden', String(!active));
            });
          };

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (animate && document.startViewTransition && !reduceMotion) {
            document.startViewTransition(apply);
          } else {
            apply();
          }
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rockeron-setup-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rockeron-setup-library')) {
    class RockeronSetupLibrary extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.trainer = this.querySelector('[data-rsl-trainer]');
        this.front = this.querySelector('[data-rsl-front]');
        if (!this.trainer || !this.front) return;
        const params = new URL(location.href).searchParams;
        for (const [key, control] of [['trainer',this.trainer],['front',this.front]]) {
          const value = params.get(key);
          if (value && Array.from(control.options).some(option => option.value === value)) control.value = value;
        }
        this.onChange = () => this.update(true);
        this.trainer.addEventListener('change', this.onChange);
        this.front.addEventListener('change', this.onChange);
        this.update(false);
        this.querySelector('form')?.addEventListener('formdata', event => {
          const value = event.formData.get('comment[body]');
          const context = this.querySelector('[data-rsl-comment-context]')?.textContent.trim();
          if (value && context && !String(value).startsWith(context)) event.formData.set('comment[body]', context + '\n\n' + value);
        });
      }
      update(writeUrl) {
        const trainer = this.trainer.value;
        const front = this.front.value;
        const available = (this.dataset.supportedTrainers || '').split(',').includes(trainer);
        this.querySelectorAll('[data-rsl-supported]').forEach(element => { element.hidden = !available; });
        this.querySelectorAll('[data-rsl-unavailable]').forEach(element => { element.hidden = available; });
        this.querySelectorAll('[data-rsl-front-name]').forEach(element => { element.textContent = this.front.selectedOptions[0].textContent; });
        this.querySelectorAll('[data-rsl-variant]').forEach(element => { element.hidden = element.dataset.rslVariant !== trainer; });
        this.querySelectorAll('[data-rsl-support]').forEach(element => { element.hidden = element.dataset.rslSupport !== front; });
        this.querySelectorAll('[data-rsl-link]').forEach(link => {
          const url = new URL(link.href, location.origin);
          url.searchParams.set('trainer', trainer);
          url.searchParams.set('front', front);
          const current = new URL(location.href);
          for (const key of ['preview_theme_id','_fd','pb']) {
            if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
          }
          link.href = url.href;
        });
        const context = this.querySelector('[data-rsl-comment-context]');
        if (context) context.textContent = this.dataset.context + ' · ' + this.trainer.selectedOptions[0].textContent + ' · ' + this.front.selectedOptions[0].textContent;
        if (writeUrl) {
          const url = new URL(location.href);
          url.searchParams.set('trainer', trainer);
          url.searchParams.set('front', front);
          history.replaceState({}, '', url);
        }
      }
    }
    customElements.define('rockeron-setup-library', RockeronSetupLibrary);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rockeron-ultra-modes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rockeron-ultra-modes-loop')) {
    customElements.define('rockeron-ultra-modes-loop', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.visible = false;
        this.userPaused = false;
        this.expectedPauses = 0;
        this.video.muted = true;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onPause = () => {
          if (this.expectedPauses > 0) this.expectedPauses -= 1;
          else this.userPaused = true;
        };
        this.onPlay = () => { this.userPaused = false; };
        this.onVisibility = () => this.updatePlayback();
        this.onMotion = () => this.updatePlayback();
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('play', this.onPlay);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onMotion);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.35;
            this.updatePlayback();
          }, { threshold: [0, 0.35] });
          this.observer.observe(this);
        }
      }
      pauseVideo() {
        if (!this.video.paused) {
          this.expectedPauses += 1;
          this.video.pause();
        }
      }
      updatePlayback() {
        if (!this.visible || document.hidden || this.motion.matches) {
          this.pauseVideo();
          return;
        }
        if (!this.userPaused && this.video.paused) {
          this.video.play().then(() => {
            if (!this.isConnected || !this.visible || document.hidden || this.motion.matches) this.pauseVideo();
          }).catch(() => {});
        }
      }
      disconnectedCallback() {
        if (!this.video) return;
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.motion.removeEventListener('change', this.onMotion);
        this.video.removeEventListener('pause', this.onPause);
        this.video.removeEventListener('play', this.onPlay);
        this.video.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rockeron-video-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rockeron-video-guide')) {
    customElements.define('rockeron-video-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const video = this.querySelector('video');
        const choices = [...this.querySelectorAll('[data-rvg-choice]')];
        const playlist = this.hasAttribute('data-playlist');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const controller = new AbortController();
        const options = { signal: controller.signal };
        let current = 0, inView = false, userPaused = false, ignoredPauses = 0;
        const pause = () => {
          if (!video.paused) { ignoredPauses++; video.pause(); }
        };
        const play = () => video.play().catch(() => {});
        const autoPlay = () => {
          if (inView && !document.hidden && !reduced.matches && !userPaused) play();
        };
        const select = (index, manual = false) => {
          pause();
          current = index;
          const choice = choices[current];
          video.poster = choice.dataset.poster;
          video.src = choice.href;
          video.setAttribute('aria-label', choice.textContent.trim());
          choices.forEach(item => item === choice ? item.setAttribute('aria-current', 'true') : item.removeAttribute('aria-current'));
          video.load();
          if (manual) { userPaused = false; play(); } else autoPlay();
        };
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-rvg-choice]');
          if (!choice || !this.contains(choice)) return;
          event.preventDefault();
          select(choices.indexOf(choice), true);
        }, options);
        video.addEventListener('play', () => {
          userPaused = false;
        }, options);
        video.addEventListener('pause', () => {
          if (ignoredPauses) { ignoredPauses--; return; }
          if (!video.ended) userPaused = true;
        }, options);
        video.addEventListener('ended', () => {
          if (playlist && choices.length > 1) select((current + 1) % choices.length);
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) pause(); else autoPlay();
        }, options);
        reduced.addEventListener('change', () => {
          if (reduced.matches) pause(); else autoPlay();
        }, options);
        const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
          inView = entries[0].isIntersecting;
          if (inView) autoPlay(); else pause();
        }) : null;
        if (observer) observer.observe(video);
        else { inView = true; autoPlay(); }
        this.cleanup = () => { pause(); controller.abort(); if (observer) observer.disconnect(); };
      }
      disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
